import App from "app";
import Backbone from "backbone";
import api from "core/api/api";
import utils from "core/utils";
import _ from "underscore";

const MAX_NUMBER_OF_EVENTS = 100;

export default function(streamFQN) {
    _.extend(this, Backbone.Events);
    var isRunning = false;
    var nsName = utils.getNamespace(streamFQN).toUpperCase();
    var name = utils.getName(streamFQN).toUpperCase();
    var eventID = nsName + "." + name + ":data";
    var streamName = nsName + "." + name + "";

    var that = this;
    App.vent.on(eventID, function(event) {
        that.numberOfEvents++;
        if (isRunning) {
            if (that.numberOfEvents <= MAX_NUMBER_OF_EVENTS) {
                that.trigger("onDataLoaded", event.event.data);
            }
        }
    });

    this.numberOfEvents = 0;

    this.start = function() {
        isRunning = true;
        that.numberOfEvents = 0;
        api.showStream(streamName, MAX_NUMBER_OF_EVENTS)
            .done(function() {
                isRunning = true;
            })
            .fail(function(e) {
                isRunning = false;
            });
    };

    this.stop = function() {
        isRunning = false;
        App.vent.off(eventID);
    };
}
